import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';
import React from 'react';
import './FullPageLoadingLayer.scss';

export type ExpressCheckoutLoadingLayerProps = {
    isShown?: boolean;
    children?: React.ReactElement;
};

export const FullPageLoadingLayer: React.FC<
    ExpressCheckoutLoadingLayerProps
> = ({ isShown = false, children }) => {
    if (!isShown) {
        return null;
    }

    return (
        <div className="full-page-loading-layer" aria-live="polite">
            <div data-spec="spinner">
                <ProgressIndicator style="gradient" />
            </div>
            {children}
        </div>
    );
};
